import { render } from "./QbeekForgotPassword.vue?vue&type=template&id=5a7ebbfa"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/QbeekForgotPassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a7ebbfa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a7ebbfa', __exports__)) {
    api.reload('5a7ebbfa', __exports__)
  }
  
  module.hot.accept("./QbeekForgotPassword.vue?vue&type=template&id=5a7ebbfa", () => {
    api.rerender('5a7ebbfa', render)
  })

}


export default __exports__